<template>
  <div class="date-picker" v-loading="dateLoading">
    <el-select
      :placeholder="fromDashboard && fieldPlaceholder ? fieldPlaceholder : 'Pick date range'"
      v-model="field.selected_date_picker"
      :size="'mini'"
      @change="setDatePickerDate"
      clearable
    >
      <el-option
        v-for="(el, index) in pickerOptions"
        :key="el.value + '_' + index"
        :value="el.value"
        :label="el.label"
      >
        {{ el.label }}
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment';
  import CustomDashboardConfig from '@/mixins/CustomDashboardHelper.js';

  export default {
    mixins: [CustomDashboardConfig],
    computed: {
      ...mapGetters('auth', ['getDefaultDateFormat']),
    },
    props: {
      field: Object,
      fromDashboard: Boolean,
      fieldPlaceholder: String,
    },
    mounted() {
      // if (!this.field.selected_date_picker) {
      //   this.$set(this.field, "selected_date_picker", "");
      // }
    },
    data() {
      return {
        dateLoading: false,
        pickerOptions: [
          {
            label: 'Today',
            value: 'today',
          },
          {
            label: 'Yesterday',
            value: 'yesterday',
          },
          {
            label: 'Tomorrow',
            value: 'tomorrow',
          },
          {
            label: 'Last 7 Days',
            value: 'last_7_days',
          },
          {
            label: 'Last 15 days',
            value: 'recent',
          },
          {
            label: 'Past 30 days',
            value: 'past_30_days',
          },
          {
            label: 'Last week',
            value: 'last_week',
          },
          {
            label: 'Last week-to-date',
            value: 'last_week_to_date',
          },
          {
            label: 'This week',
            value: 'this_week',
          },
          {
            label: 'This week-to-date',
            value: 'this_week_to_date',
          },
          {
            label: 'Next week',
            value: 'next_week',
          },
          {
            label: 'Last month',
            value: 'last_month',
          },
          {
            label: 'Last month-to-date',
            value: 'last_month_to_date',
          },
          {
            label: 'This month',
            value: 'this_month',
          },
          {
            label: 'This month-to-date',
            value: 'this_month_to_date',
          },
          {
            label: 'Next month',
            value: 'next_month',
          },
          {
            label: 'Last quarter',
            value: 'last_quarter',
          },
          {
            label: 'Last quarter-to-date',
            value: 'last_quarter_to_date',
          },
          {
            label: 'This quarter',
            value: 'this_quarter',
          },
          {
            label: 'This quarter-to-date',
            value: 'this_quarter_to_date',
          },
          {
            label: 'Next quarter',
            value: 'next_quarter',
          },
          {
            label: 'Last year',
            value: 'last_year',
          },
          {
            label: 'Last year-to-date',
            value: 'last_year_to_date',
          },
          {
            label: 'This year',
            value: 'this_year',
          },
          {
            label: 'This year-to-date',
            value: 'this_year_to_date',
          },
          {
            label: 'Next year',
            value: 'next_year',
          },
        ],
      };
    },
    methods: {
      updateDateValue(picker) {
        console.log('picker', picker);
      },
      setDatePickerDate(value) {
        let data = this.getDatePickerHelper(value);
        if (this.fromDashboard) {
          this.$emit('dateFilterUpdated', {
            ...data,
            ...{
              entity_id: this.field.entity_id,
              operator: value,
              filter: this.field,
            },
          });
        } else {
          this.field.value = data.value;
          this.field.today = data.today;
        }
      },
      checkPicker(ev) {
        const format = 'MM-DD-YYYY';
        let dt = moment(ev).format(format);
        let today = moment(new Date()).format(format);
        // let yesterday =
        // let weekAgo = moment
        if (dt == today) {
          this.field.selected_date_picker = 'today';
        } else {
          this.field.selected_date_picker = 'past';
        }
      },
    },
  };
</script>
